var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asd-form"},[_c('AttachmentsList',{attrs:{"attachments":_vm.attachments}}),_c('AttachmentsNew',{attrs:{"id":_vm.entityId,"evidence":"project"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }